
import React, {Component} from "react";



import "./levels-widget.css";


class LevelsWidget extends Component {

    render () {
        let {current_step} = this.props;


        let level = Math.floor(current_step / 5) + 1;

        let stepOutOfFive = (current_step - 1) % 5;

        let daysToNextLevel = 5 - stepOutOfFive;

        if (daysToNextLevel === 0) {
            daysToNextLevel = 5;
        }


        let daysString = "days";
        if (daysToNextLevel === 1) {
            daysString = "day";
        }

        let daysToNextLevelText = level < 7 ? daysToNextLevel + " more " + daysString + " to level " + (level + 1) : "";

        
        return (
            <div className='progress_map_widget_container'>
                <div className='levels_widget_title'>Level</div>
                <div className='levels_widget_level'>{level}</div>
                <div className='levels_widget_days_to_next_level'>
                    {daysToNextLevelText} 
                </div>
                
            </div>
        );
        
    }
}

export default LevelsWidget;


// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/progress-map/widgets/levels-widget.js